<template>
  <div class="cookie-modal">
    <p>依據歐盟施行的個人資料保護法，我們致力於保護您的個人資料並提供您對個人資料的掌握。</p>
    <p
      >按一下「全部接受」，代表您與許我們置放 Cookie 來提升您在本網站的使用體驗、協助我們分析網站效能和使用狀況，以及讓我們投 <br />放相關聯的行銷內容。您可以在下方管理 Cookie
      設定。按一下「確認」即代表您同意目前採用的設定。</p
    >
    <div class="d-flex justify-content-center mt-4">
      <BaseButton class="isStylePrimary isSizeGetcode isOutline mr-4" @click="openCookieDialog">管理 Cookies</BaseButton>
      <BaseButton class="isStylePrimary isSizeGetcode" @click="acceptCookie">全部接受</BaseButton>
    </div>
    <CookieDialog :visible="showCookieDialog" @accept="acceptCookie" @close="closeCookieDialog" />
  </div>
</template>

<script>
import CookieDialog from '@components/Dialog/CookieDialog'
import { saveLocalStorage } from '@utils/localStorage'

export default {
  name: 'CookieModal',
  components: {
    CookieDialog,
  },
  data: () => {
    return {
      showCookieDialog: false,
    }
  },
  methods: {
    acceptCookie() {
      saveLocalStorage('zerone-cookie', true)
      this.$emit('close', true)
    },
    openCookieDialog() {
      this.showCookieDialog = true
    },
    closeCookieDialog() {
      this.showCookieDialog = false
    },
  },
}
</script>

<style lang="scss">
.cookie-modal {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: white;
  text-align: center;
  padding: 20px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

@media(max-width: 768px) {
  .cookie-modal {
    margin-bottom: 140px;
  }
}
</style>
